import BaseService from './baseService'
import EndPoints from '@/constants/dxApiEndpoints'
import { FilterTypes } from '@/constants/productInsights'
import { ProductParameterRequest } from '@/types/productParamter'
import { ProductParmeter } from '@/types/ProductInsights'

class ProductParameterService extends BaseService {
  getProductParameters = async (
    businessProfileId: number,
    filterType: number[] = [FilterTypes.ATTRIBUTE, FilterTypes.METRIC]
  ): Promise<ProductParmeter[]> => {
    const response = await this.apiClient.get<{
      data: ProductParmeter[]
    }>(EndPoints.ProductParameters(businessProfileId), {
      filterType: filterType
    })
    const productParameters: ProductParmeter[] = response?.data
    return productParameters
  }

  addProductParameters = async (
    businessProfileId: number,
    requestData: ProductParameterRequest
  ): Promise<number> => {
    const response = await this.apiClient.post<{
      data: number
    }>(EndPoints.ProductParameters(businessProfileId), requestData)
    const createdId: number = response?.data
    return createdId
  }
}

export default ProductParameterService
